import { OrderTypeEnum } from '@core/enums';
import { OrderType } from '@core/models';
import { createAction, props } from '@ngrx/store';

export const ORDER_TYPE_FIND = createAction('[Order Type] Find');
export const ORDER_TYPE_FIND_SUCCESS = createAction('[Order Type] Find Success', props<{ orderTypeList: OrderType[] | null}>());
export const ORDER_TYPE_FAILED = createAction('[Order Type] Failed', props<{ error: string }>());
export const ORDER_TYPE_UPDATE_LOADING = createAction('[Order Type] Update Loading', props<{ loading: boolean }>());
export const ORDER_TYPE_UPDATE = createAction('[Order Type] Update', props<{ orderType: OrderTypeEnum }>());
